<template>
  <div class="themed-bg min-h-screen p-4 pb-20">
    <!-- Header -->
    <div class="flex justify-between items-center mb-4">
      <div>
        <h2 class="text-2xl font-bold">Mosquito Control</h2>
        <p class="themed-text-secondary">Intelligent pest management system</p>
      </div>
      <ThemeToggle />
    </div>

    <!-- Mosquito Control Component -->
    <MosquitoControl />
  </div>
</template>

<script setup>
import ThemeToggle from '@/components/ThemeToggle.vue'
import MosquitoControl from '@/components/MosquitoControl.vue'
</script>
